// import React, { useEffect, useState, useCallback } from "react";
// // import API from "../Services/PriceType";
// import API from '../Services/SalesTab'

// const DisplayOrder = ({ selectedDisplayOrder, setSelectedDisplayOrder }) => {

//     const [displayOrder, setDisplayOrder] = useState([]);
//     const [error, setError] = useState(null);

//     const handleChange = (e) => {
//         setSelectedDisplayOrder(e.target.value);
//     };

//     const bindDisplayOrder = async () => {
//         try {
//             const response = await API.getDisplayOrder();
//             // console.log("respinse datat",response?.data)
//             setDisplayOrder(response?.data?.displayOrder);
//         } catch (error) {
//             setError("Failed to fetch Display Order.");
//             console.error(error);
//             if (error.response.status === 403) {
//                 window.location.replace("/Login");
//             }
//         }
//     };
//     useEffect(() => {
//         bindDisplayOrder();
//     }, []);

//     return (
//         <div className="row">
//             <div className="col-md-12">
//                 <label htmlFor="Designation" className="mb-1">Display Order <span style={{ color: "red" }}>*</span></label>
//                 <select className="form-select" id="ddltype" value={selectedDisplayOrder}
//                   multiple
//                   onChange={handleChange} >
//                     <option value="">Select</option>
//                     {displayOrder.length > 0 ? (
//                         displayOrder.map((item) => (
//                             <option key={item.id} value={item.id}>
//                                 {item.order}
//                             </option>
//                         ))
//                     ) : (
//                         <option disabled>No DisplayOrder available</option>
//                     )}
//                 </select>
//                 {/* {error && <p style={{ color: 'red' }}>{error}</p>} */}
//                 {/* </div> */}
//             </div>
//         </div>
//     );
// };

// export default DisplayOrder;


import React, { useEffect, useState } from "react";
// import API from "../Services/PriceType";
import API from "../Services/SalesTab";

const DisplayOrder = ({ selectedDisplayOrder, setSelectedDisplayOrder }) => {
  const [displayOrder, setDisplayOrder] = useState([]);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setSelectedDisplayOrder(e.target.value);
  };

  const bindDisplayOrder = async () => {
    try {
      const response = await API.getDisplayOrder();
      setDisplayOrder(response?.data?.displayOrder);
    } catch (error) {
      setError("Failed to fetch Display Order.");
      console.error(error);
      if (error.response?.status === 403) {
        window.location.replace("/Login");
      }
    }
  };

  useEffect(() => {
    bindDisplayOrder();
  }, []);

  const selectStyle = {
    paddingTop: "10px",        // Moves text downward
    paddingBottom: "10px",     // Moves text upward
    fontSize: "14px",          // Adjust text size
    lineHeight: "1.8",         // Adjust vertical spacing
    height: "auto",            // Let height adapt
  };

  const optionStyle = {
    fontSize: "14px",
    padding: "8px",            // Some browsers ignore this
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <label htmlFor="ddltype" className="mb-1">
          Display Order <span style={{ color: "red" }}>*</span>
        </label>
        <select
          className="form-select"
          id="ddltype"
          value={selectedDisplayOrder}
       //   multiple
          onChange={handleChange}
          style={selectStyle}
        >
          <option value="">Select</option>
          {displayOrder.length > 0 ? (
            displayOrder.map((item) => (
              <option key={item.id} value={item.id} style={optionStyle}>
                {item.order}
              </option>
            ))
          ) : (
            <option disabled>No DisplayOrder available</option>
          )}
        </select>
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>
    </div>
  );
};

export default DisplayOrder;
